import PropTypes from 'prop-types';
import React, { memo } from 'react';
import clsx from 'clsx';
import { UploadCloud } from 'react-feather';
import './default-file-upload.scss';
import FeaturedIcon, { FeaturedIconColors, FeaturedIconSizes } from '../../../featured-icon';
import useTranslation from '../../../../../utils/translation-utils';
import Typography from '../../../typography';

const DefaultFileUpload = ({
  disabled, primaryMsg, supportingMsg,
}) => {
  const [getTranslation] = useTranslation();

  return (
    <div className={clsx('default-file-upload', { disabled })}>
      <FeaturedIcon
        type={UploadCloud}
        className="dfu-cloud-icon"
        size={FeaturedIconSizes.MEDIUM}
        color={disabled ? FeaturedIconColors.DARK : FeaturedIconColors.PRIMARY}
      />
      <div className="dfu-messages">
        <div className="fum-primary-message">
          <Typography
            className="mpm-first-primary"
            variant={Typography.Variants.sm}
            fontWeight={Typography.FontWeight.medium}
            color={disabled ? Typography.Colors.gray300 : Typography.Colors.primary700}
          >
            {`${primaryMsg} `}
          </Typography>
          <Typography
            className="mpm-second-primary"
            variant={Typography.Variants.sm}
            color={Typography.Colors.gray500}
            fontWeight={Typography.FontWeight.regular}
          >
            {getTranslation('OR_DRAG_AND_DROP')}
          </Typography>
        </div>
        <Typography
          className="mpm-secondary"
          variant={Typography.Variants.xs}
          color={Typography.Colors.gray500}
          fontWeight={Typography.FontWeight.regular}
        >
          {supportingMsg}
        </Typography>
      </div>
    </div>
  );
};

DefaultFileUpload.defaultProps = {
  primaryMsg: '',
  disabled: false,
  supportingMsg: '',
};

DefaultFileUpload.propTypes = {
  disabled: PropTypes.bool,
  primaryMsg: PropTypes.string,
  supportingMsg: PropTypes.string,
};

export default memo(DefaultFileUpload);
